import { Types } from 'lib/generated_constants/projects';
import * as propTypes from 'lib/prop_types';
import { studyLengthPropType } from 'lib/prop_types/projects/details';

/*
NOTE: As we built out new Serializers, we should be putting props into `lib/prop_types`
 */

export const compensationInfoPropType = propTypes.shape({
  amount: propTypes.oneOfType([propTypes.number, propTypes.string]),
  compensationType: propTypes.string,
  compensationTypeId: propTypes.number,
});

export const demographicRulePropShape = propTypes.shape({
  displayName: propTypes.string.isRequired,
  id: propTypes.string.isRequired,
  isIgnore: propTypes.bool,
  optionId: propTypes.string,
  optionIds: propTypes.arrayOf(propTypes.string),
  options: propTypes.arrayOf(
    propTypes.shape({
      displayName: propTypes.string.isRequired,
      id: propTypes.string.isRequired,
      isDefault: propTypes.bool.isRequired,
    }),
  ),
  optionSelectionType: propTypes.number.isRequired,
  range_end: propTypes.string,
  range_start: propTypes.string,
  uuid: propTypes.string,
});

export const inPersonInterviewInfoShape = {
  parkingIsAvailable: propTypes.bool,
  parkingAdditionalInfo: propTypes.string,
};

export const onlineInterviewInfoShape = {
  deviceRequirements: propTypes.array.isRequired,
  deviceRequirementsOptions: propTypes.array.isRequired,
  deviceSentence: propTypes.string,
};

export const phoneInterviewInfoShape = {
  researcherWillCall: propTypes.bool,
};

export const interviewInfoPropType = propTypes.shape({
  ...inPersonInterviewInfoShape,
  ...onlineInterviewInfoShape,
  ...phoneInterviewInfoShape,
});

export const projectCustomEmailFieldPropType = propTypes.shape({
  example: propTypes.string,
  name: propTypes.string.isRequired,
  notes: propTypes.object,
  required: propTypes.bool.isRequired,
  tag: propTypes.string.isRequired,
  type: propTypes.string,
  value: propTypes.string,
});

export const projectCustomEmailPropType = propTypes.shape({
  content: propTypes.string,
  defaultCopy: propTypes.string.isRequired,
  errors: propTypes.objectOf(propTypes.string),
  fields: propTypes.arrayOf(projectCustomEmailFieldPropType).isRequired,
  fromAddress: propTypes.string,
  fromName: propTypes.string,
  id: propTypes.oneOfType([propTypes.number, propTypes.string]),
  projectId: propTypes.number,
  subject: propTypes.string,
  type: propTypes.string.isRequired,
});

export const projectRangePropType = propTypes.shape({
  endDate: propTypes.string,
  endTime: propTypes.string,
  numScheduled: propTypes.number,
  numSlots: propTypes.number,
  startDate: propTypes.string,
  startTime: propTypes.string,
  uuid: propTypes.string.isRequired,
});

export const projectPropType = propTypes.shape({
  accountId: propTypes.number,
  compensationInfo: compensationInfoPropType,
  customEmails: propTypes.arrayOf(projectCustomEmailPropType),
  demographicRules: propTypes.arrayOf(demographicRulePropShape),
  errors: propTypes.objectOf(propTypes.string).isRequired,
  id: propTypes.number,
  interviewInfo: interviewInfoPropType,
  publicTitle: propTypes.string,
  ranges: propTypes.arrayOf(projectRangePropType).isRequired,
  studyLength: studyLengthPropType,
  studyTypeId: propTypes.number,
  targetProfessionals: propTypes.bool,
  type: propTypes.oneOf(Object.values(Types)).isRequired,
  useEmailTheme: propTypes.bool.isRequired,
});
